import {Directive, ElementRef, OnInit} from '@angular/core';

@Directive({
  selector: 'input[autoWidth]',
})
export class AutoWidthDirective implements OnInit {
  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    this.adjustInputWidth();
  }

  private adjustInputWidth() {
    const placeholder = this.elementRef.nativeElement.getAttribute('placeholder');
    if (placeholder) {
      const placeholderLength = placeholder.length;
      const width = placeholderLength; // 根据字符长度设置宽度，这里假设每个字符宽度为10px
      this.elementRef.nativeElement.style.width = `${width + 2}em`;
    }
  }
}
